import fetch from 'isomorphic-fetch'

class TimeZoneApi {
  static get(coordinates) {
    const key = process.env.REACT_APP_GOOGLE_MAPS_KEY || 'AIzaSyDz2K09VVCnj1JtEi--STBbZ99JAepBWqw'
    const time = +Math.floor(Date.now() / 1000)

    return fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${coordinates}&timestamp=${time}&key=${key}`, {
      method: 'GET'
    })
      .then((response) => response.json().then((json) => ({ json, response })))
      .catch((error) => {
        return error
      })
  }

  static getByPlaceId = (placeId) => {
    return new Promise((resolve, reject) => {
      if (!placeId) return reject()

      // Skip geocoding for manual entries (fallback when Google API unavailable)
      if (placeId.startsWith('manual-')) {
        return resolve({ timeZoneId: 'America/New_York', timeZoneName: 'Eastern Standard Time' })
      }

      if (!window.google?.maps?.Geocoder) {
        return resolve({ timeZoneId: 'America/New_York', timeZoneName: 'Eastern Standard Time' })
      }

      try {
        const geocoder = new window.google.maps.Geocoder()
        const result = geocoder.geocode({ placeId }, (results, status) => {
          if (status !== 'OK' || !results || !results[0]) {
            return reject()
          }

          const data = results[0]
          const { geometry: { location } } = data
          this.get([location?.lat(), location?.lng()])
            .then(({ response: { ok }, json }) => {
              if (ok) {
                const { timeZoneId, timeZoneName } = json
                resolve({ timeZoneId, timeZoneName })
              } else {
                reject()
              }
            })
            .catch(reject)
        })
        // geocode may return a promise or undefined depending on API state
        if (result && result.catch) {
          result.catch(reject)
        }
      } catch {
        resolve({ timeZoneId: 'America/New_York', timeZoneName: 'Eastern Standard Time' })
      }
    })
  }
}

export default TimeZoneApi
